(function () {
    var MOBILE_WIDTH_SIZE = 1024;

    /* 제이쿼리 이징 */
    $.easing.easeOutQuad = function (a, b, c, d, e) {
        return -d * (b /= e) * (b - 2) + c;
    };

    /**
     * @callback clickInpPrdItem
     * @param {*} e
     * @return {myCallback} [상품 클릭 시 활성화 표시]
     */
     function clickInpPrdItem(e) {
        $(e.currentTarget).parents(".item").toggleClass("on");
    }
    
     /**
     * @callback clickBtnTotPrd
     * @param {*} e
     * @return {myCallback} [MO  > 합계 버튼 클릭 시 펼침, 숨김 토글]
     */
    function clickBtnTotPrd(e) {
        var $wrap = $(e.currentTarget).closest(".col-right");
        var $totPrdWrap = $('.totals-product');

        var $colRightDim = document.querySelector('.col-right-dim');

        if ($wrap.hasClass("open")) {
            //팝업 닫기
            $wrap.stop().animate(
                {
                    top: $(window).outerHeight(true) - $totPrdWrap.outerHeight(),
                },
                300,
                "easeOutQuad",
                function () {
                    $wrap.removeClass("open");
                    $colRightDim && $colRightDim.classList.remove("show");
                    $("html, body").css("overflow", "");

                    $wrap.css({
                        top: "inherit",
                        bottom: 0,
                    });
                }
            );
        } else {
            //팝업 열기
            $wrap.addClass("open");
            $colRightDim && $colRightDim.classList.add("show");
            $wrap.find(".product-recommend-wrap").scrollTop(0);

            $wrap.css({ top: $(window).outerHeight(true) - $totPrdWrap.outerHeight() });
            $wrap.stop().animate(
                {
                    top: 0,
                },
                300,
                "easeOutQuad",
                function () {
                    $("html, body").css("overflow", "hidden");
                    $wrap.css({
                        top: 0,
                        bottom: "inherit",
                    });
                }
            );
        }
    }

    /**
     * @callback clickBtnShowAll
     * @param {*} e
     * @return {myCallback} [다품목 계산 > 전체보기 토글]
     */
    function clickBtnShowAll(e) {
        e.preventDefault();
        var $listbox = $(e.currentTarget).parents(".product-list-area").find(".product-list-box");
        $listbox.toggleClass("on");
        $(e.currentTarget).toggleClass("on");
        if ($(e.currentTarget).hasClass("on")) {
            $(e.currentTarget).text("간단히 보기");
            $listbox.children().eq(1).attr('tabindex', 0).focus().one('focusout', function () {
                $(this).removeAttr('tabindex');
            })
        } else {
            $(e.currentTarget).text("전체보기");
        }
    }
    
     /**
     * @callback clickBtnAmount
     * @return {myCallback} [결제가 토글]
     */
      function clickBtnAmount(e) {
        var target = $(this);
        var parent = target.closest('.box-total-amount-wrap');
        parent.toggleClass('on');
        target.attr('aria-expanded', parent.hasClass('on'));

        // BTOCSITE-77414 [웹앱 접근성 개선활동] 전시_이벤트/멤버십
        var text = target.find('.text').text();
        var blind = target.find('.blind');
        blind.html(text + ' 내용 ' + (parent.is('.on') ? '닫기' : '열기'));

        var width =  $(window).outerWidth();
      }
     /**
     * @callback clickBtnTipBox
     * @return {myCallback} [결제가 팁박스]
     */
      function clickBtnTipBox(e) {
        var parent = $(this).closest('.tip-box');
            parent.hide('fast', function(){
                $(this).remove()
            })
      }

    function bindEvents() {
        // 상품 리스트 체크박스 클릭시 
        // $('.promo-wrap').on('click', '.product-itemck input', clickInpPrdItem);

        // 모바일 > 계산기
        $('.promo-wrap .totals-product-btn').on('click', clickBtnTotPrd);

        // 모바일 > 계산기 전체보기 
        $('.promo-wrap .product-list-area .btn-link').on("click", clickBtnShowAll);

        $('.promo-wrap .btn-amount').attr('aria-expanded', false).on("click", clickBtnAmount);

        // 팁박스
        $('.promo-wrap .tip-box .btn-close').on('click', clickBtnTipBox);
    }

    function resize() {
        $(window).on('resize', function(e){
            var width =  $(window).outerWidth();

            if(width > 1024) {
                var $wrap = $(".col-right");
                if ($wrap.hasClass("open")) {
                    $wrap.removeClass("open");
                    $wrap.attr('style','');
                    $("html, body").css("overflow", "");
                }
                $( ".promo-wrap .box-total-amount-wrap" ).each(function( index ) {
                    $(this).removeClass('on');
                });
                
                
            }else  {
                $( ".promo-wrap .box-total-amount-wrap" ).each(function( index ) {
                    $(this).addClass('on');
                });
                
            }

            initBottomBtnArea();
            twinTypeReflow(width > 1024);  //[주문][BTOCSITE-83434][EPIC] 구독 다품목 적용
        });
    }

    function initBottomBtnArea() {
        var self = this;            
        var $bottomBtnArea = $('.product-view .payment-amount-info');

        if ($bottomBtnArea.length > 0) {
            // BTOCSITE-68538 [모니터링 G][APP] Chatbot 아이콘 위에 Top버튼이 노출

            var floatingWrap = document.querySelector(".floating-wrap");
            var btnFloatingWrap = document.querySelector(".btn-floating-wrap");

            if (floatingWrap && btnFloatingWrap) {
                if (window.innerWidth <= 1024) {
                    var areaH = parseInt($bottomBtnArea.css('paddingTop')) || 0;
                    floatingWrap.style.setProperty('--bottom', areaH + 'px');
                    btnFloatingWrap.style.setProperty('--bottom', areaH + 'px');
                } else {
                    floatingWrap.style.removeProperty('--bottom');
                    btnFloatingWrap.style.removeProperty('--bottom');
                }
                
            }
        }
    }
    // S [주문][BTOCSITE-83434][EPIC] 구독 다품목 적용
    function twinTypeReflow (isPC){
        $('ul.twin-type > li').each(function(index, el){
            var $item = $(el)
            var productContents = $item.find('.product-contents');
            var productBottom = $item.find('.product-bottom');
            var productBenefit = $item.find('.product-benefit');
            var pbPaddingBottom = !isPC ? productBenefit.height() : 0;
            productBottom.find('.price-area').css({paddingBottom: pbPaddingBottom});
            var positionTop = productContents.height() + productBottom.outerHeight();
            productBenefit.css({top: positionTop});
        });
    }
    // E [주문][BTOCSITE-83434][EPIC] 구독 다품목 적용
    

    function swiper() {
        var swiperM = new Swiper('.comp-swiper', {
            slidesPerView: "auto",
            freeMode: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },
            breakpoints: {
                767: {
                    freeMode: false,
                }
            }
        });
    }

    $(window).ready(function () {
        bindEvents();
        resize();

        initBottomBtnArea();
        twinTypeReflow();  //[주문][BTOCSITE-83434][EPIC] 구독 다품목 적용
        swiper();

        $('.totals-product-btn').not('.on').on('click',function(){
            //다품목 계산기 오픈시
            lgkorUI.showAppBottomMenu(false);
            lgkorUI.setEnableAppScrollBottomMenu(false);
        });
        $('.totals-product-btn.on').on('click',function(){
            //다품목 계산기 닫기시
            lgkorUI.showAppBottomMenu(true);
            lgkorUI.setEnableAppScrollBottomMenu(true);
        });


        //BTOCSITE-92996 다품목 계산기 기능 새로운 타입 2뎁스 탭 설정 
        var currentTab1 = '' 
        var stickyId = setInterval(function () {
            if( $('.tabs-depth1-wrap.ui_stickyTab').parent().hasClass('ui_sticky_wrap')){
                clearInterval(stickyId);
                var $depthTab1 = $('.tabs-depth1-wrap.ui_stickyTab');
                var $depthTab2 = $('.tabs-depth2-wrap .view-type');
                $depthTab1.parent().append($('.tabs-depth2-wrap'));
                $depthTab2.vcStickyTab();

            
                setTimeout(function(){
                    $depthTab1.on('stickyTabchange',function(e,_obj){
                        $depthTab2.vcSmoothScroll('update');
                        
                        var idName = _obj.button.attr('href');
                        if( $(idName+' li.on').length == 1 ){
                            $(idName+' li.on a').trigger('click');
                        }
                    });

                    $depthTab2.on('stickyTabchange',function(e,_obj){
                        $(window).scrollTop($('.tabs-depth1-wrap').parent().parent().offset().top);

                        currentTab1 = $('.tabs-depth1-wrap li.on a').attr('href').replace('#','');
                        var idName = _obj.button.attr('href');
                        if( $(idName).attr('data-depth1') == currentTab1 ){
                            $('.tab-content').addClass('off')
                            $(idName).removeClass('off').addClass('on')
                        }
                    });

                    $('.tabs-depth2-wrap>div').each(function(index, el){
                        var idName =  $(this).attr('id');
                        $(this).find('li').each(function(index, el){
                            $($(this).find('a').attr('href')).attr('data-depth1',idName)
                        })
                    });
                    
                    $depthTab1.find('li.on a').trigger('click');
                    $('.tabs-depth2-wrap').css('visibility', 'visible');
                },20);
            }
        },20);
    });
})();
